import styled from 'styled-components';

export default styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.warning};
`;
